import { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { cmsActions } from '../../reducers/cms.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import PermissionsAdd from './PermissionsAdd.modal';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import Table from '../common/table/Table.react';
import AccessRestricted from '../app/routing/AccessRestricted.react';
import permissionGroupDict from '../../helpers/dictionary/permissionGroupDict';
var Constants = function Constants(_ref) {
  var permissionsAction = _ref.permissionsAction,
    addModalAction = _ref.addModalAction;
  useEffect(function () {
    permissionsAction({});
  }, []);
  var cmsPermissions = useSelector(function (s) {
    return s.cms.permissions;
  });
  if (!useHasPermission('view-permissions')) return /*#__PURE__*/React.createElement(AccessRestricted, null);
  var columns = {
    title: 'Title',
    group: 'Group',
    key: 'Key',
    description: 'Description'
  };
  var data = Object.values(cmsPermissions).map(function (x) {
    return {
      description: x.description,
      group: permissionGroupDict[x.group] || '',
      key: x.key,
      title: x.title
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Permissions",
    button: {
      label: 'Add',
      type: 'add',
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(PermissionsAdd, null)
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: data,
    sort: {
      by: 'title'
    }
  }))));
};
var mdtp = {
  permissionsAction: cmsActions.permissions,
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(Constants);